import { useEffect, useState } from 'react';
import { useGeneratedPresignedUrlByAttachmentId } from 'remote-state/attachments';

import { StyledAttachmentChipWrapper } from './StyledAttachmentChip';
import Thumbnail from '../../../common/components/thumbnail';
import { fileIcon } from './attachmentIcons';

export const AttachmentChip = (props) => {
  const {
    attachmentId,
    extension,
    originalName,
    isDeleted,
    isReadOnly,
    isDownloaded,
    onAttachmentDeleted,
    deleteAttachmentEnabled,
  } = props;
  const icon = fileIcon(extension);
  const {
    data: { downloadUrl: url },
  } = useGeneratedPresignedUrlByAttachmentId({ attachmentId });
  const [isAttachmentAvailable, setIsAttachmentAvailable] = useState(false);
  const isImage = icon === 'image';
  const showDeleteBtn = deleteAttachmentEnabled && (!isReadOnly || (isReadOnly && !isDeleted && !isDownloaded));

  useEffect(() => {
    const img = new Image();

    img.src = url;
    img.onload = () => setIsAttachmentAvailable(true);
  }, [url]);

  return (
    <StyledAttachmentChipWrapper
      data-cy={`attachment-uploader-chip-${attachmentId}`}
      disabled={isDeleted || !isAttachmentAvailable}
      showTitle={!isImage}
      showDownloadBtn={deleteAttachmentEnabled}
      showDeleteBtn={showDeleteBtn}
    >
      <Thumbnail
        attachmentId={attachmentId}
        index={0}
        extendedFileName={originalName}
        extension={extension}
        fileId={attachmentId}
        isDefaultImage={isImage && !isAttachmentAvailable}
        onAttachmentDeleted={onAttachmentDeleted}
        onDisplayPreview={() => {}}
      />
    </StyledAttachmentChipWrapper>
  );
};
